import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader
        speed={2}
        viewBox="0 0 400 920"
        backgroundColor={'#eee'}
        foregroundColor={'#ccc'}
    >
        {/* 免邮 */}
        <rect x="0" y="0" width="400" height="65" />
        {/* 优惠券 */}
        <rect x="0" y="66" width="400" height="65" />
        {/* 礼物 */}
        <rect x="10" y="141" width="380" height="240" />
        {/* 产品 */}
        <circle cx="24" cy="466" r="9"/>
        <rect x="48" y="401" width="100" height="125" />
        <rect x="158" y="401" width="200" height="25" />
        <rect x="158" y="431" width="80" height="25" />
        <rect x="158" y="471" width="100" height="25" />

        <circle cx="24" cy="621" r="9"/>
        <rect x="48" y="556" width="100" height="125" />
        <rect x="158" y="556" width="200" height="25" />
        <rect x="158" y="586" width="80" height="25" />
        <rect x="158" y="636" width="100" height="25" />
        {/* <rect x="10" y="548" width="380" height="155" /> */}
        {/* 推荐 */}
        <rect x="10" y="713" width="150" height="25" rx="15" />
        <rect x="10" y="748" width="380" height="155" />

        {/* <circle cx="60" cy="140" r="40" />
        <rect x="115" y="110" width="260" height="25" rx="15" />
        <rect x="115" y="150" width="260" height="25" rx="15" />
        <rect x="20" y="190" width="75" height="75" rx="25" />
        <rect x="110" y="190" width="75" height="75" rx="25" />
        <rect x="200" y="190" width="75" height="75" rx="25" />
        <rect x="290" y="190" width="75" height="75" rx="25" />
        <rect x="10" y="280" rx="15" width="380" height="100" />
        <rect x="10" y="395" rx="15" width="380" height="100" />
        <rect x="30" y="510" width="160" height="40" />
        <rect x="210" y="510" width="160" height="40" />
        <rect x="10" y="560" width="380" height="300" /> */}
    </ContentLoader>
}